import { render, staticRenderFns } from "./goodsMakeList.vue?vue&type=template&id=3043937c&scoped=true"
import script from "./goodsMakeList.vue?vue&type=script&lang=js"
export * from "./goodsMakeList.vue?vue&type=script&lang=js"
import style0 from "./goodsMakeList.vue?vue&type=style&index=0&id=3043937c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3043937c",
  null
  
)

export default component.exports